var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
        },
        [
          _c("div", { staticClass: "custom-toolbar md-layout" }, [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item custom-toolbar-start md-layout md-small-size-80 md-size-90",
              },
              [
                _c("team-members-filter", {
                  attrs: { "default-value": _vm.initialTeamMember },
                  on: { onSelection: _vm.onTeamMemberSelection },
                }),
                _c(
                  "div",
                  { staticClass: "md-layout-item" },
                  [
                    _c("date-range-filter", {
                      attrs: {
                        "is-single-date": true,
                        "default-date": _vm.initialDate,
                      },
                      on: { onChanged: _vm.onDateChanged },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "md-layout-item custom-toolbar-end" },
              [
                _c(
                  "md-button",
                  {
                    staticClass:
                      "md-primary md-just-icon md-round pull-right header-button",
                    attrs: { title: "Export Stops report" },
                    on: { click: _vm.onExportToExcel },
                  },
                  [_c("md-icon", [_vm._v("get_app")])],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
        },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-header",
                { staticClass: "md-card-header-icon md-card-header-blue" },
                [
                  _c(
                    "div",
                    { staticClass: "card-icon" },
                    [_c("md-icon", [_vm._v("summarize")])],
                    1
                  ),
                ]
              ),
              _c("md-card-content", [
                !_vm.reports || _vm.reports.length == 0
                  ? _c("div", [
                      _c("h3", [_vm._v("Stop Report")]),
                      _c("p", [
                        _vm._v(
                          "\n                            No results to display.\n                        "
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "report-container" },
                        [
                          _c("md-table", {
                            staticClass: "table-hover",
                            attrs: { value: _vm.reports },
                            scopedSlots: _vm._u([
                              {
                                key: "md-table-row",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return _c(
                                    "md-table-row",
                                    {},
                                    [
                                      _c("md-table-cell", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(index + 1) +
                                            "\n                                    "
                                        ),
                                      ]),
                                      _c(
                                        "md-table-cell",
                                        {
                                          attrs: {
                                            "md-label": "Type",
                                            "md-sort": "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.tripState) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Date/Time" } },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("timeFormat")(
                                                  item.startTime,
                                                  _vm.DATE_TYPES.standardTime
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Suburb" } },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.startSuburb) +
                                              " - " +
                                              _vm._s(item.endSuburb) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Distance" } },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.totalDistanceKm) +
                                              " kms\n                                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Duration" } },
                                        [
                                          _vm._v(
                                            _vm._s(item.durationMin) + " mins"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }